import styled from 'styled-components';

import BoxButton, { BOX_BUTTON_COLOR, BOX_BUTTON_SIZE } from '@/components/atom/buttons/BoxButton';
import HelpQuestion from '@/components/atom/icon/search/HelpQuestion';

interface Props {
  handleClickRequestButton: (buttonPosition: string) => void;
}

const EmptyResult = ({ handleClickRequestButton }: Props) => {
  const handleButtonClick = () => {
    handleClickRequestButton('middle');
  };

  return (
    <Wrapper>
      <EmptyResultWrapper>
        <HelpQuestion />
        <EmptyResultTitle>지금 궁금한 내용은 뭐였나요?</EmptyResultTitle>
        <EmptyResultOffer>
          필요한 정보를 알려주시면
          <br />
          검색 결과 개선에 큰 도움이 돼요
        </EmptyResultOffer>
        <ButtonSection>
          <BoxButton size={BOX_BUTTON_SIZE.LARGE} color={BOX_BUTTON_COLOR.PRIMARY} onClick={handleButtonClick}>
            정보 요청하기
          </BoxButton>
        </ButtonSection>
      </EmptyResultWrapper>
    </Wrapper>
  );
};

export default EmptyResult;

const Wrapper = styled.div`
  display: inline-grid;
  width: 100%;
  height: calc(100vh - 180px);
  text-align: center;
  align-items: center;
`;

const EmptyResultWrapper = styled.div``;

const EmptyResultTitle = styled.div`
  ${({ theme }) => theme.typography.UI20SB};
  color: ${({ theme }) => theme.color.gray600};
  margin-top: 20px;
`;

const EmptyResultOffer = styled.div`
  ${({ theme }) => theme.typography.UI15R};
  color: ${({ theme }) => theme.color.gray400};
  margin: 8px 0 20px;
`;

const ButtonSection = styled.div`
  justify-content: center;
  display: flex;
`;
